export default function formatPhone(phone) {
  if (!phone) return;

  phone = phone.trim();
  while (phone.indexOf(" ") > 0) {
    let i = phone.indexOf(" ");
    phone = phone.substring(0, i) + phone.substring(i + 1, phone.length);
  }
  return phone;
}
